import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePreview } from './components/InsidePreview';
import { InstantAccess } from './components/InstantAccess';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
type AppProps = {
  showCountdownBar?: boolean;
  showBonuses?: boolean;
};
export function App({
  showCountdownBar = true,
  showBonuses = true
}: AppProps) {
  return <div className="w-full bg-cream" data-id="element-0" data-mp="23ujha3i1d6za">
      <MetaPixel data-id="element-1" data-mp="23ti5fwt74ggi" />
      {showCountdownBar && <CountdownBar data-id="element-2" data-mp="3iiwdijzxza14" />}
      <main data-id="element-3" data-mp="3ijfv1zlojwem">
        <Hero data-id="element-4" data-mp="3ijpef4c7z5bc" />
        <StatsBar data-id="element-5" data-mp="3ii4qvyobommz" />
        <Difference data-id="element-6" data-mp="3mlaxj7fckftz" />
        <Recognize data-id="element-7" data-mp="3mkhlps1j704z" />
        <WhatsInside data-id="element-8" data-mp="3mjzs7369700r" />
        <InsidePreview data-id="element-9" data-mp="3mjg93j4va5l5" />
        <InstantAccess data-id="element-10" data-mp="3rcj6y3gog175" />
        {showBonuses && <Bonuses data-id="element-11" data-mp="3rdkgg3i1ofmr" />}
        <Offer data-id="element-12" data-mp="3rd19fhtxnbni" />
        <Guarantee data-id="element-13" data-mp="3relu8fqg3g86" />
        <Testimonials data-id="element-14" data-mp="5orh0l86u6j" />
        <Faq data-id="element-15" data-mp="4wvvprmowg9" />
      </main>
      <Footer data-id="element-16" data-mp="5gbv0xpxarn" />
    </div>;
}